import Styleguide from "@toolkit/Framework/Types/Styleguide";

const loadingSpinner: Styleguide["loadingSpinner"] = {
    defaultProps: {
        size: 40,
    },
};

export default loadingSpinner;
